export default function testStorage(){
    try {
      localStorage.getItem('teste');
      return true;
    } catch (error) {
      return false;
    }
}